// 1. Require the Storyblok client
import StoryblokClient from 'storyblok-js-client';
import { fetchAuthSession } from 'aws-amplify/auth';
import amplifyOutputs from '../amplify_outputs.json';

// 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
// from the editor itself.
window.storyblok?.init?.();

const apiConfig = Object.values(amplifyOutputs.custom?.API ?? {})[0];
const storyblokApiUrl = apiConfig ? `${apiConfig.endpoint}/storyblok` : process.env.VUE_APP_URL;

if (!storyblokApiUrl) {
  throw new Error('The Storyblok proxy endpoint is not configured.');
}

const storyapi = new StoryblokClient({}, storyblokApiUrl);

storyapi.client.interceptors.request.use(async (config) => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken;

  if (!idToken) {
    throw new Error('An authenticated session is required to access Storyblok.');
  }

  config.headers = {
    Authorization: `Bearer ${idToken.toString()}`,
    ...config.headers,
  };
  return config;
});

export default storyapi;
